// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/lib/nonnaBasket.ts
// 🔧 PURPOSE: Il Cestino della Nonna nel catalogo: un ARTICOLO del servizio
//             dei kit (comfort_kits → kit_nonna_basket), non un servizio suo.
//             Qui gli id e la sua illustrazione, così Home ed Extra parlano
//             dello stesso articolo e mostrano la stessa figura.
//
//             L'illustrazione sta nell'app (public/images/extras), non nel
//             channel manager: il catalogo manda per l'articolo quella
//             generica dei kit. Attenzione: guestAssetUrl porta i percorsi
//             relativi sul channel manager, quindi questa NON ci deve passare
//             come percorso relativo: dove la foto passa da guestAssetUrl
//             (righe degli articoli, ricerca del negozio) si usa l'indirizzo
//             completo dell'app (basketImageUrl), che guestAssetUrl lascia
//             com'è.
// ============================================

/** Il servizio dei kit, che contiene il Cestino. */
export const BASKET_SERVICE_ID = 'comfort_kits';
/** L'articolo "Il Cestino della Nonna" dentro i kit. */
export const BASKET_VARIANT_ID = 'kit_nonna_basket';
/** L'illustrazione dedicata (percorso dell'app, non del channel manager). */
export const BASKET_IMAGE = '/images/extras/nonna-basket.svg';

/** true per l'articolo Cestino della Nonna. */
export const isNonnaBasket = (serviceId: string | null | undefined, variantId: string | null | undefined): boolean =>
  serviceId === BASKET_SERVICE_ID && variantId === BASKET_VARIANT_ID;

/** L'illustrazione con l'indirizzo completo dell'app (guestAssetUrl non la tocca). */
export const basketImageUrl = (): string => {
  try {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    if (origin && origin !== 'null') return `${origin}${BASKET_IMAGE}`;
  } catch {
    // niente window (test, prerender): il percorso relativo
  }
  return BASKET_IMAGE;
};

/** La foto di un articolo del catalogo: il Cestino ha la sua illustrazione, gli altri quella del catalogo. */
export const variantImageUrl = (
  serviceId: string | null | undefined,
  variantId: string | null | undefined,
  imageUrl: string | undefined,
): string | undefined => (isNonnaBasket(serviceId, variantId) ? basketImageUrl() : imageUrl);
